export interface InitialValues {}

export const initialValues = {
  notifications: [],
};

export default initialValues;
